import { Component, Prop, Vue } from 'vue-property-decorator';
import { MORE_TEXT } from './const';
import { Items } from './types';

@Component
export default class CalendarMonthProps extends Vue {
  // Props
  @Prop({ type: Array, required: true })
  items: Items;

  @Prop({ type: Number, required: true })
  month: number;

  @Prop({ type: String, default: MORE_TEXT })
  moreText: string;  

  @Prop({ type: Number, required: true })
  year: number;
}



// WEBPACK FOOTER //
// ./src/components/calendar/month/props.ts